<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">VC Math</h1>
                <span class="meta"> Posted in February 2024 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/vc-math.jpg" alt="">
                </figure>

                <p>Before embarking on a fundraising journey from VC, every founder should first reflect on whether venture capital funding is appropriate for their company. </p>
                <p>Financial backing from a VC firm, especially if it's a good one, can provide potentially heroic benefits to a startup. </p>
                <p>However, depending on a founder's level of ambition and personal motivation, VC funding is not desirable for everyone. Bootstrapping a company while retaining full control can be a more appealing path for some founders, as is building a profitable lifestyle business. Such aspirations are perfectly fine and commendable, though they are generally not compatible with the venture capital model.</p>
                <p>The raison d'etre of venture capital is to provide a high-risk / high-return asset class to investors in the fund. An investor's allocation to a VC fund -- whether they be an institutional asset manager, a family office, a high net worth individual, or even a retail investor -- often represents a component of a diversified investment portfolio. Given the high risk profile of the projects in which a typical VC fund invests (i.e. startups), the VC fund's investors expect high potential financial returns, usually in the range of 20-30% annualized over the lifetime of the fund.</p>
                <p>Of course, there are exceptions to the above parameters, but these generally hold true for most VC funds.</p>
                <p>So let's break this down further. If we take an average 25% internal rate of return expectation (IRR), the VC fund can only invest in startups which offer the potential promise of meeting this threshold, and ideally with far higher upside. Another way to think about it is that an IRR of 25% equates to a return of over 5x in 7 years or over 10x in 10 years, net of fund management fees. We must also take into account the dilution effect of follow-on financing rounds. The quantity, frequency, size, and parameters of such follow-on rounds will vary depending on the startup's performance but for this back-of-the-envelope estimate, I will assume a 50% dilution on the initial VC capital over the life of the investment. For VC funds that only focus on growth stage startups, this dilution effect will be lower.</p>
                <p>The result is that every investment the VC fund makes should offer the potential of returning at least 10x in 7 years or 20x in 10 years. For growth stage VC funds, the lower dilution effect renders the result closer to 5-8x in 7 years, but the principle is the same.</p>
                <p>For a founder, knowing the return expectations of the venture capital model will enable you to determine whether VC financing is appropriate for you, and if so, to be better prepared for your VC pitch meeting.</p>
                
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
